import BillingsOrderCargoRailyRecalculateResponse, {
  BillingsOrderCargoRailyRecalculateResponseDataBillingNode,
  BillingsOrderCargoRailyRecalculateResponseDataCargoOrder,
  BillingsOrderCargoRailyRecalculateResponseDataContract,
  BillingsOrderCargoRailyRecalculateResponseDataContractBillingModel,
  BillingsOrderCargoRailyRecalculateResponseDataContractCargoCompany,
} from "../../../../../api/raily/billings/order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate.response";
import BillingModel from "../../../../../types/billing-model";
import BillingsOrderCargoRailyRecalculate, {
  BillingsOrderCargoRailyRecalculateBillingNode,
  BillingsOrderCargoRailyRecalculateCargoOrder,
  BillingsOrderCargoRailyRecalculateContract,
  BillingsOrderCargoRailyRecalculateContractCargoCompany,
} from "./billings-order-cargo-raily-recalculate";

const createContractCargoCompany = (
  cargoCompany: BillingsOrderCargoRailyRecalculateResponseDataContractCargoCompany,
): BillingsOrderCargoRailyRecalculateContractCargoCompany => {
  return {
    companyName: cargoCompany.companyName,
  };
};

const createContractModel = (
  model: BillingsOrderCargoRailyRecalculateResponseDataContractBillingModel,
): BillingModel => {
  switch (model) {
    case BillingsOrderCargoRailyRecalculateResponseDataContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsOrderCargoRailyRecalculateResponseDataContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsOrderCargoRailyRecalculateResponseDataContractBillingModel.OTHER:
      return BillingModel.OTHER;
    case BillingsOrderCargoRailyRecalculateResponseDataContractBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createContract = (
  contract: BillingsOrderCargoRailyRecalculateResponseDataContract,
): BillingsOrderCargoRailyRecalculateContract => {
  return {
    allowChargeDuringRide: contract.allowChargeDuringRide,
    allowChargeWhileApproaching: contract.allowChargeWhileApproaching,
    allowChargeWhileReturning: contract.allowChargeWhileReturning,
    cargoCompany: createContractCargoCompany(contract.cargoCompany),
    discountLimit: contract.discountLimit,
    distanceRate: contract.distanceRate,
    haltingTimeAfterMinutes: contract.haltingTimeAfterMinutes,
    haltingTimeRate: contract.haltingTimeRate,
    model: createContractModel(contract.model),
  };
};

const createBillingNode = (
  billingNode: BillingsOrderCargoRailyRecalculateResponseDataBillingNode,
): BillingsOrderCargoRailyRecalculateBillingNode => {
  return {
    allowCharge: billingNode.allowCharge,
    checkoutDate: billingNode.checkoutDate,
    checkoutEventId: billingNode.checkoutEventId,
    description: billingNode.description,
    distance: billingNode.distance,
    editableCoordinates: billingNode.editableCoordinates,
    haltingTime: billingNode.haltingTime,
    highwayCharge: billingNode.highwayCharge,
    id: billingNode.id,
    lat: billingNode.lat,
    lon: billingNode.lon,
    nodeId: billingNode.nodeId,
    orderId: billingNode.orderId,
    plannedDate: billingNode.plannedDate,
    plannedDistance: billingNode.plannedDistance,
  };
};

const createBillingNodes = (
  billingNodes: BillingsOrderCargoRailyRecalculateResponseDataBillingNode[],
): BillingsOrderCargoRailyRecalculateBillingNode[] => {
  return billingNodes.map(createBillingNode);
};

const createCargoOrder = (
  cargoOrder: BillingsOrderCargoRailyRecalculateResponseDataCargoOrder,
): BillingsOrderCargoRailyRecalculateCargoOrder => {
  return {
    humanId: cargoOrder.humanId,
    id: cargoOrder.id,
  };
};

const create = (
  response: BillingsOrderCargoRailyRecalculateResponse,
): BillingsOrderCargoRailyRecalculate => {
  const data = response.data;

  return {
    billingNodes: createBillingNodes(data.billingNodes),
    cargoOrder: createCargoOrder(data.cargoOrder),
    contract: createContract(data.contract),
    date: data.date,
    discount: data.discount,
    discountAmount: data.discountAmount,
    distance: data.distance,
    distanceAmount: data.distanceAmount,
    haltingAmount: data.haltingAmount,
    highwayCharge: data.highwayCharge,
    planEntryId: data.planEntryId,
    totalAmount: data.totalAmount,
  };
};

const billingsOrderCargoRailyRecalculateFactory = {
  create,
};

export default billingsOrderCargoRailyRecalculateFactory;
